import { Link } from 'react-router-dom';
import logo from "../assets/logos/Anathameenakshi_no_bg.png"

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-obsidian-paper border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16">
          {/* Brand */}
              <div className="mt-8 w-38 h-32 flex items-center justify-center">
                <img
                               src={logo}
                               alt="AnanthaMeenakshi Architect's logo"
                               className="h-auto w-auto object-cover"
                             />
              </div>
          <div>
            
            <div class="mt-8">
                <span className="font-heading text-lg font-semibold text-gold">AnanthaMeenakshi </span>
                <span className="font-heading text-lg font-semibold text-white ml-1">Architect's & Associates</span>
              </div>
            <p className="mt-3 text-gray-400 text-sm leading-relaxed">
              Building excellence through innovation, quality, and unwavering commitment to our clients' visions.
            </p>
          </div>

        {/* Companies */}
          <div className='mt-8 ml-4 mb-8'>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Our Companies</h4>
            <ul className="space-y-3">
           <li>
                <span className="text-gray-400 ">
                Ananthameenakshi Architects
                </span>
              </li>
              <li>
                <span className="text-gray-400 ">
                  Ananthameenakshi & Sriram Associates
                </span>
              </li>
              <li>
                <span className="text-gray-400 ">
                  Ananthameenakshi & Meenakshi Agency
                </span>
              </li> 
              <li>
                <span className="text-gray-400 ">
                   Ananthameenakshi Developers
                </span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className='mt-8 ml-4 mb-8'>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Services
                </a>
              </li>
              <li>
                <a href="#projects" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Projects
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} AnanthaMeenakshi Group. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-gray-500 text-xs uppercase tracking-wider">
              Build · Design · <span> <Link 
                  to="/admin" 
                  className=" hover:text-gold transition-colors "
                  data-testid="admin-link"
                >Material</Link></span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
